export default "__VITE_ASSET__Uu1sIpxp__"